import { defineNuxtPlugin } from "nuxt/app";

export default defineNuxtPlugin({
  name: "ckweb:user-hooks",
  dependsOn: ["ckweb:auth", "ckweb:dev-console", "ckweb:sentry"],
  async setup($nuxt) {
    const authStore = useAuthStore();
    const { setUser: setErrorReportingContext } = useReportError();

    $nuxt.$auth.addEventCallback(async (event) => {
      switch (event.type) {
        case "auth-busy-state-change":
          devConsole.info("📣 ckAuth: custom Nuxt Hook call ckauth:busy");
          $nuxt.callHook("ckauth:busy", event.detail);
          break;
        case "auth-token-refresh-failed":
          devConsole.info("📣 ckAuth: custom Nuxt Hook call ckauth:token-refresh-failed");
          $nuxt.callHook("ckauth:token-refresh-failed", event.detail);
          break;
        case "auth-logout":
          authStore.resetCurrentUser();
          devConsole.info("📣 ckAuth: custom Nuxt Hook call ckauth:logout");
          $nuxt.callHook("ckauth:logout");
          break;
        case "auth-initialize-error":
        case "auth-provider-error":
        case "auth-login-error":
          $nuxt.$sentryCaptureException(event.detail);
          break;
      }
    });

    $nuxt.hook("ckauth:user-loaded", ({ currentUser }) => {
      const context = {
        username: authStore.currentAccountUsername,
        name: authStore.currentAccount?.name,
        id: authStore.currentAccount?.id,
        email: currentUser?.email,
        userId: currentUser?.userId,
        fullName:
          currentUser?.firstName && currentUser?.lastName
            ? `${currentUser.firstName} ${currentUser.lastName}`
            : authStore.currentAccount?.name,
      };
      devConsole.info(`🛠️ ckAuth: User context set for error reporting`, context);
      setErrorReportingContext(context);
    });

    await authStore.initialize();

    devConsole.info("🛠️ ckAuth: auth store initialized and hooked  🚀🚀🚀🚀🚀");
  },
});
